import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var Content = function Content(_ref) {
  var children = _ref.children;
  return _jsx(MenuContent, {
    role: "menu",
    children: children
  });
};

var MenuContent = /*#__PURE__*/_styled("div", true ? {
  target: "e1wud37t0"
} : {
  target: "e1wud37t0",
  label: "MenuContent"
})(true ? {
  name: "hmxbog",
  styles: "display:flex;flex-direction:column;justify-content:space-between;gap:24px"
} : {
  name: "hmxbog",
  styles: "display:flex;flex-direction:column;justify-content:space-between;gap:24px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvTmF2aWdhdGlvbi9Nb2JpbGVOYXZpZ2F0aW9uL0NvbnRlbnQvQ29udGVudC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBUThCIiwiZmlsZSI6Ii93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvTmF2aWdhdGlvbi9Nb2JpbGVOYXZpZ2F0aW9uL0NvbnRlbnQvQ29udGVudC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdHlwZSB7IEZDLCBIVE1MQXR0cmlidXRlcywgUHJvcHNXaXRoQ2hpbGRyZW4gfSBmcm9tICdyZWFjdCdcblxuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmV4cG9ydCBjb25zdCBDb250ZW50OiBGQzxIVE1MQXR0cmlidXRlczxIVE1MRGl2RWxlbWVudD4gJiBQcm9wc1dpdGhDaGlsZHJlbj4gPSAoeyBjaGlsZHJlbiB9KSA9PiAoXG4gIDxNZW51Q29udGVudCByb2xlPVwibWVudVwiPntjaGlsZHJlbn08L01lbnVDb250ZW50PlxuKVxuXG5jb25zdCBNZW51Q29udGVudCA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbiAgZ2FwOiAyNHB4O1xuYFxuXG5leHBvcnQgZGVmYXVsdCBDb250ZW50XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export default Content;